module.exports = __webpack_public_path__ + "img/HS0006.6bfe936.jpg";